import React from "react";
import { Box, Typography, Button, Grid, Paper } from "@mui/material";
import { BsArrowDownCircleFill } from "react-icons/bs";
function Info({ label, value }) {
    return (
        <Box>
            <Typography variant="body2" fontWeight="bold">
                {label}
            </Typography>
            <Typography variant="body2" color="text.secondary">
                {value}
            </Typography>
        </Box>
    );
}
export default function VideoPlayer({ data, download_name = Date().toString() }) {
    const videoList = data.video_urls
    const videoRef = React.useRef(null);
    const [currentIndex, setCurrentIndex] = React.useState(0);

    const handleVideoEnd = () => {

        if (currentIndex < videoList.length - 1) {
            console.log("Loaded", currentIndex + 1)
            setCurrentIndex(currentIndex + 1);
            setTimeout(() => {
                try {
                    videoRef.current?.play(); // ensure autoplay
                } catch (err) {

                }
            }, 100); // slight delay to let src update
        } else {
            console.log("All videos finished!");
        }
    };

    const handleDownload = () => {
        const url = data?.video_urls?.[0];
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${download_name}-video.mp4`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    return (
        <Box>
            <Grid container spacing={2} sx={{ flexGrow: 1 }}>
                <Grid size={{ xs: 12, sm: 9 }}>
                    {videoList?.length > 0 &&
                        <video ref={videoRef} width="100%" controls autoPlay style={{ borderRadius: 8 }}
                            onEnded={handleVideoEnd}
                            key={videoList[currentIndex]}
                        >
                            <source src={videoList[currentIndex]} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>}
                </Grid>
                <Grid size={{ xs: 12, sm: 3 }}>
                    <Box>
                        <Info label="Name" value={data.name} />
                        <Info label="Created" value={data.created_at} />
                        <Info label="Status" value={data.status} />
                        <Info label="Camera" value={data.camera} />
                        <Info label="Frame Count" value={data.frame_count} />
                        <BsArrowDownCircleFill onClick={() => handleDownload()} />
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
}